export const asociativeParams = (parametros) => {
  const obj = {};
  parametros.map((d) => {
    obj[d.codigo] = {
      valor: d.valor,
      observaciones: d.observaciones,
    };
    return null;
  });
  return obj;
};
